import { EffectCallback, useEffect } from 'react'

export const useMount = (mount: EffectCallback) => useEffect(mount, [])
